import React, {
  FC, memo, useEffect, useMemo, 
} from 'react';
import { Button } from 'components';
import { useTranslation } from 'react-i18next';
import { marketingPlanVideoPoster, officeVideoPosterImage, aboutHubVideoPosterImage } from 'assets/images';

import styles from './styles.module.scss';

interface MainPageVideoContainerProps {
  language: string;
}

export const MainPageVideoContainer:FC<MainPageVideoContainerProps> = memo(({ language }) => {
  const [videoId, setVideoId] = React.useState<number>(0);
  const { t } = useTranslation('welcome');

  const videos = useMemo(() => [
    {
      id: 0,
      title: t('Marketing_plan_'),
      src: `https://storage.googleapis.com/eclipse-cdn/videos/Marketing-plan-2-${language || 'en'}.mp4`,
      poster: marketingPlanVideoPoster,
    },
    {
      id: 1,
      title: t('About_hub_'),
      src: `https://storage.googleapis.com/eclipse-cdn/videos/About_hub_${language || 'en'}.mp4`,
      poster: aboutHubVideoPosterImage,
    },
    {
      id: 2,
      title: t('Our_office_'),
      src: 'https://storage.googleapis.com/eclipse-cdn/videos/OfficeVideo.mp4',
      poster: officeVideoPosterImage,
    },
    {
      id: 3,
      title: t('Instructions_'),
      src: `https://storage.googleapis.com/eclipse-cdn/videos/Instructions-${language || 'en'}.mp4`,
      poster: marketingPlanVideoPoster,
    },
  ], [language, t]);

  const currentVideo = videos[videoId];

  useEffect(() => {
    const preloadLinkId = 'preload-office-video-poster';

    if (!document.getElementById(preloadLinkId)) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = officeVideoPosterImage;
      link.id = preloadLinkId;
      document.head.appendChild(link);
    }
  }, []);

  return (
    <div className={styles.main_page_video_container}>
      <div className={styles.main_page_video_controller}>
        {videos.map((video) => (
          <Button
            key={video.id}
            color={videoId === video.id ? 'blue' : 'blueTransparent'}
            onClick={() => setVideoId(video.id)}
          >
            {video.title}
          </Button>
        ))}
      </div>
      <video
        className={styles.videoElement}
        src={currentVideo.src}
        poster={currentVideo.poster}
        controls
        title={currentVideo.title}
      >
        <track
          kind="captions"
          src=""
          label=""
        />
      </video>
    </div>
  );
});
